import axios from "axios";
import queryString from "query-string";

const baseUrl = process.env.REACT_APP_API_BASEURL;
const token = process.env.REACT_APP_API_TOKEN;

// Please create the `.env` file in the project root to configure api's calls.
// See README.md


const getCulture = (newCulture) => {
  let culture = "en-gb";
  if (newCulture) {
    const [,value] = newCulture;
      switch (value) {
          case "pl":
              culture = "pl-pl";
              break;
          case "fr":
              culture = "fr-fr";
              break;
      case "tr":
        culture = "tr-tr";
        break;
      case "it":
        culture = "it-it";
        break;
      case "de":
        culture = "de-de";
        break;
      default:
        culture = "en-gb";
        break;
    }
  }

  return culture;
}

const headers = {
  token,
};
const fetcher = (endpoint, queryParams) => {
  let { culture = "en-gb" } = queryString.parse(window.location.search);
  culture = getCulture(window.location.pathname.split('/'));
  
  // executing the fetch only if there're no params with undefined values
  if (
    queryParams &&
    Object.values(queryParams).filter((o) => o === undefined).length > 0
  )
    return Promise.reject(new Error("no params"));

  const url = queryString.stringifyUrl({
    url: baseUrl + endpoint,
    query: {
      culture,
      ...queryParams,
    },
  });

  return axios.get(url, { headers }).then((res) => res.data);
};

const poster = (endpoint, body) => {
  let { culture = "en-gb" } = queryString.parse(window.location.search);
  culture = getCulture(window.location.pathname.split('/'));

  const url = queryString.stringifyUrl({
    url: baseUrl + endpoint,
    query: {
      culture,
    },
  });

  return axios
    .post(url, body, {
      headers: {
        ...headers,
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data);
};

export { fetcher, poster, getCulture };
